import React from "react";

type ContextType = {
  unit: any,
  documentTypes: any[],
  refresh: any,
  formValues: any,
  submit: any,
  isSubmitting: boolean,
  isValid: boolean
}
export default React.createContext<ContextType>({
  unit: null,
  documentTypes: [],
  refresh: null,
  formValues: null,
  submit: null,
  isSubmitting: false,
  isValid: false
})